import React from "react";
import { HeaderList } from "../../Components/Header/HeaderList";
import { Card, Grid, Paper, Typography } from "@mui/material";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";
import {
  customValidation,
  validations,
} from "../../commonFunctions/CommonFunctions";
import WSPhone from "../../Components/Phone/WSPhone";
import WSSelectField from "../../Components/Select/WSSelect";
import WSButton from "../../Components/Button/WSButton";

export const TelecallingCrm: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  return (
    <>
      <HeaderList
        title={"Telecalling CRM"}
        type="card"
        position="relative"
        isBackButton={true}
        url="/products"
      />

      <Grid container spacing={2} mt={2} p={3}>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ padding: 2 }}>
                <Grid display="flex" flexDirection="column" alignItems="center">
                  <WSIcons.LocalPhoneIcon fontSize="large" />
                  <Typography variant="body1" mt={1} textAlign={"center"}>
                    AutoDialer With Multiple Calling Methods
                  </Typography>
                  <Typography variant="body2" mt={1} textAlign={"center"}>
                    Get a modern dialer with automated outbound calling, instant
                    multichannel engagement, follow-up management, and call &
                    lead statistics
                  </Typography>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ padding: 2 }}>
                <Grid display="flex" flexDirection="column" alignItems="center">
                  <WSIcons.UserGroup fontSize="large" />
                  <Typography variant="body1" mt={1} textAlign={"center"}>
                    Comprehensive Lead Management
                  </Typography>
                  <Typography variant="body2" mt={1} textAlign={"center"}>
                    A single platform to consolidate, segregate, assign, track
                    and manage all your leads from multiple sources
                  </Typography>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ padding: 2 }}>
                <Grid display="flex" flexDirection="column" alignItems="center">
                  <WSIcons.AssignmentIcon fontSize="large" />
                  <Typography variant="body1" mt={1} textAlign={"center"}>
                    Real-time Performance Analytics
                  </Typography>
                  <Typography variant="body2" mt={1} textAlign={"center"}>
                    Get actionable, real-time insights into your team's
                    performance. Filter and analyze individual performance, and
                    drive higher levels of productivity{" "}
                  </Typography>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
<Grid item xs={12} sm={6}>
    <Paper elevation={0} sx={{ p: 3 }}>
      <Typography mb={2}>Please Fill The Form Below</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTextField label="Enter First Name *" {...register("firstName")} id="firstName" name="firstName" control={control} />
        </Grid>
        <Grid item xs={12}>
          <WSTextField label="Enter Last Name *" {...register("lastName")} id="lastName" name="lastName" control={control} />
        </Grid>
        <Grid item xs={12}>
          <WSTextField label="Enter Company Name *" {...register("companyName")} id="companyName" name="companyName" control={control} />
        </Grid>
        <Grid item xs={12}>
          <WSTextField
            id="email"
            type={TextType.Text}
            rules={customValidation(false, validations.email)}
            {...register("email")}
            label="Enter Email*"
            control={control}
          />
        </Grid>
        <Grid item xs={12}>
          <WSPhone label="Enter Mobile Number" id="mobileNumber" name="mobileNumber" control={control} rules={{ required: true }} />
        </Grid>
        <Grid item xs={12}>
          <WSSelectField
            rules={{ required: true }}
            control={control}
            id="telecallerTeamSize"
            {...register("telecallerTeamSize")}
            name="telecallerTeamSize"
            label="Telecaller Team Size *"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <WSButton
            id="submit"
            type="submit"
            label="Apply Now"
            size="medium"
            variant="outlined"
            color="primary"
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "#FFFFFF",
              backgroundColor: "rgba(126, 176, 246, 1)",
              "&:hover": { backgroundColor: "rgba(126, 176, 246, 1)" }
            }}
          />
        </Grid>
      </Grid>
    </Paper>
          </Grid>
        </Grid>
    </>
  );
});
